@if (navigationService.useMobileNav$ | async) {
    <div class="utility">
        <div class="utility-object">
            <fui-navigation-search id="search"></fui-navigation-search>
        </div>
    </div>
}
<div class="main" [class.mobile]="navigationService.useMobileNav$ | async">
    <fui-navigation-trees (clickOutside)="resetActiveTree()" id="trees" [trees]="trees"></fui-navigation-trees>
</div>
